import icon from "../../assets/contact.svg";
import type { Property } from "../../types";

export const directory: Property = {
  id: "directory",
  title: "directory.title",
  icon,
};
